import { TClientsTableSortableField } from 'types/state';
import { M8UserSortableField } from 'services/production/types';
import { UnreachableError } from 'utils/errors';

export const normalzieClientsTableSortableField = (
  field: TClientsTableSortableField
) => ({
  toM8UserSortableField(): M8UserSortableField {
    switch (field) {
      case 'balance':
      case 'id':
        return 'id';
      case 'fullName':
        return 'lastName';
      case 'company':
        return 'organization';
      case 'orgStaffCount':
        return 'companySize';
      case 'demoStack':
        return 'demoDnsName';
      case 'prodStack':
        return 'prodDnsName';
      case 'email':
        return 'email';
      case 'phone':
        return 'phone';
      case 'position':
        return 'position';
      case 'registeredOn':
        return 'createOn';
      case 'updatedOn':
        return 'updatedOn';
      default:
        throw new UnreachableError(field);
    }
  },
});
